import { CloseOutlined } from "@ant-design/icons";
import { useState , useMemo, useEffect} from "react";
import { Button } from "antd";

import RichTextEditor from "@components/richTextEditor";
import CommonModal from "@pages/member-details/component/modal/modal";
import { getNoteMaxLength } from "@utils/helpers";

export const NoteModal = ({ open = false, title, onCancel, onOk }: any) => {
    
  const [note, setNote] = useState<string>('');

  useEffect(() => {
    console.log("NoteModal.useEffect")
    setNote('');

    return () => {
      setNote('');
    }
  } , [open])

  const noteLength = useMemo(() => {
    console.log("NoteModal.noteLength");
    return note.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').replace(/\s+/g, ' ').trim().length;
  } ,[note]);

  return (
    <CommonModal open={open} closable={false} onOk={onOk} onCancel={onCancel}>
      <div className="activeCaseStatus">
        <div className="caseStatus-common__header">
          <div className="caseStatus-common__header__title">{title}</div>
          <div className="caseStatus-common__header__close" onClick={onCancel}>
            <CloseOutlined />
          </div>
        </div>
        <div className="activeCaseStatus__body__container1">
          <div className="activeCaseStatus__body__container1__title">Note{<span className="activeCaseStatus__body__container1__title__mandatory">*</span>}</div>
          <div className="activeCaseStatus__body__container1__text">
            <RichTextEditor
              content={note}
              changeHandler={(text: any) => {
                setNote(text);
              }}
              actionsMenu={false}
              autoFocus={true}
              showCount={true}
              wordLimit={getNoteMaxLength()}
            />
          </div>
        </div>
        <div className="caseStatus-common__footer">
          <div className="caseStatus-common__footer__cancel">
            <Button onClick={onCancel}>Cancel</Button>
          </div>
          <div className="caseStatus-common__footer__submit">
            <Button type="primary" disabled={noteLength <= 0} onClick={() => onOk(note)}>
              Submit
            </Button>
          </div>
        </div>
      </div>
    </CommonModal>
  );
};
